export default __webpack_public_path__ + "static/media/slide15.316107a9.png";